import { xunfeiAudioTranscriptionResult,xunfeiAudioTranscriptionParse } from '../api/api'

export default (path) => {
  let timeout = null;
  const getResult = (orderId) => {
    return new Promise((resolve, reject) => {
      xunfeiAudioTranscriptionResult(orderId).then(res => {
        if(res && res.status === 0){
          if(timeout != null) clearTimeout(timeout);
          timeout = null;
          resolve(res.data.text);
        }else if(res && res.status === 300){
          if(timeout != null){
            clearTimeout(timeout);
            timeout = null;
          }
          timeout = setTimeout(()=>{
            getResult(orderId).then(res => {
              resolve(res);
            }).catch(e => {
              reject(e);
            });
          },3000);
        }else{
          reject(res.message);
        }
      }).catch(e => {
        reject(e.message);
      });
    });
  };
  return new Promise((resolve, reject) => {
    xunfeiAudioTranscriptionParse(path).then(res => {
      if(res && res.status === 0){
        getResult(res.data).then(res => {
          resolve(res);
        }).catch(e => {
          reject(e);
        });
      }else{
        reject(res.message);
      }
    }).catch(e => {
      reject(e.message);
    });
  });
}



// WEBPACK FOOTER //
// ./src/util/xunfei.js